import Skeleton from '@mui/material/Skeleton';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';

export const ProviderShowDialogSkeleton = () => {
  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '172px' } } }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <TableRowWrapper key={i} label={<Skeleton />}>
          <Skeleton />
        </TableRowWrapper>
      ))}
    </CardTable>
  );
};
